export default "__VITE_ASSET__15e42dc3__"